import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n"; // important to import
const TermsAndCondition = () => {
     const { t } = useTranslation("TermsAndCondition");
    return (
        <div className="col-12 col-lg-11 pb-5">
            <div className=" overflow-hidden order-3">
                <div className=" p-4 p-md-5">
                    <h2 className="fw-600 text-black mb-3">
                      {t("title")}
                    </h2>
                    <h3>1)   {t("introduction_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                         {t("introduction_text")}
                    </p>
                    <h3>2)   {t("scope_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                        {t("scope_text_1")}
                    </p>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                         {t("scope_text_2")}
                    </p>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                        {t("scope_text_3")}
                    </p>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                        {t("scope_text_4")}
                    </p>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                        {t("scope_text_5")}
                    </p>

                    <h3>3)  {t("definitions_title")}</h3>
                    <p className="fw-500 mb-0">
                       {t("definitions_a")}
                    </p>
                    <p className="mb-1 text-bl pb-3">
                       {t("definitions_a_text")}
                    </p>

                    <p className="fw-500 mb-0"> {t("definitions_b")}</p>
                    <p className="mb-1 text-bl pb-3">
                         {t("definitions_b_text")}
                    </p>

                    <p className="fw-500 mb-0">   {t("definitions_c")}</p>
                    <p className="mb-1 text-bl pb-3">
                          {t("definitions_c_text")}
                    </p>

                    <p className="fw-500 mb-0">   {t("definitions_d")}</p>
                    <p className="mb-1 text-bl pb-3">
                        {t("definitions_d_text")}
                    </p>

                    <p className="fw-500 mb-0">   {t("definitions_e")}</p>
                    <p className="mb-1 text-bl pb-3">
                           {t("definitions_e_text")}
                    </p>

                    <p className="fw-500 mb-0"> {t("definitions_f")}</p>
                    <p className="mb-1 text-bl pb-3">
                        {t("definitions_f_text")}
                    </p>

                    <p className="fw-500 mb-0"> {t("definitions_g")}</p>
                    <p className="mb-1 text-bl pb-3">
                        {t("definitions_g_text")}
                    </p>

                    <p className="fw-500 mb-0"> {t("definitions_h")}</p>
                    <p className="mb-1 text-bl pb-3">
                       {t("definitions_h_text")}
                    </p>

                    <p className="fw-500 mb-0"> {t("definitions_i")}</p>
                    <p className="mb-1 text-bl pb-3">
                         {t("definitions_i_text")}
                    </p>

                    <p className="fw-500 mb-0">  {t("definitions_j")}</p>
                    <p className="mb-1 text-bl pb-3">
                         {t("definitions_j_text")}
                    </p>

                    <p className="fw-500 mb-0">  {t("definitions_k")}</p>
                    <p className="mb-1 text-bl pb-3">
                        {t("definitions_k_text")}
                    </p>

                   <p className="fw-500 mb-0">  {t("definitions_l")}</p>
                    <p className="mb-1 text-bl pb-3">
                        {t("definitions_l_text")}
                    </p>

                   <p className="fw-500 mb-0">  {t("definitions_m")}</p>
                    <p className="mb-1 text-bl pb-3">
                        {t("definitions_m_text")}
                    </p>


                   <p className="fw-500 mb-0">  {t("definitions_n")}</p>
                    <p className="mb-1 text-bl pb-3">
                        {t("definitions_n_text")}
                    </p>


                    <h3>4)  {t("subject_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                        {t("subject_text_1")}
                    </p>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                        {t("subject_text_2")}
                    </p>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                        {t("subject_text_3")}
                    </p>

                    <h3>5)  {t("prices_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                        {t("prices_text_1")}
                    </p>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                      {t("prices_text_2")}
                    </p>

                    <h3>6){t("term_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                       {t("term_text_1")}
                    </p>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                       {t("term_text_2")}
                    </p>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                         {t("term_text_3")}
                    </p>

                    <h3>7)  {t("rights_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                         {t("rights_text")}
                    </p>

                    <h3>8)   {t("liability_title")}</h3>
                    <p className="fw-500 mb-0">
                         {t("liability_a")}
                    </p>
                    <p className="mb-1 text-bl pb-3">
                         {t("liability_a_text")}
                    </p>

                    <p className="fw-500 mb-0">  {t("liability_b")}</p>
                    <p className="mb-1 text-bl pb-3">
                        {t("liability_b_text")}
                    </p>

                    <h3>9)  {t("force_majeure_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                         {t("force_majeure_text")}
                    </p>

                    <h3>10)   {t("references_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                         {t("references_text")}
                    </p>

                    <h3>11)  {t("dataprotection_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                        {t("corporate_data_title")}
                    </p>

                    <h3>12)  {t("corporate_data_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                      {t("corporate_data_text")}
                    </p>

                    <h3>13) {t("final_title")}</h3>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                       {t("final_text_1")}
                    </p>
                    <p className="fw-400 text-muted mb-3 fs-7 text-bl">
                      {t("final_text_2")} 2024
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TermsAndCondition;
